import { render, staticRenderFns } from "./TimeOffBookingBalanceCardDetail.vue?vue&type=template&id=335e9d9a&"
import script from "./TimeOffBookingBalanceCardDetail.vue?vue&type=script&lang=ts&"
export * from "./TimeOffBookingBalanceCardDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports